<div class="custom-snackbar">
    <span class="message">{{ data.message }}</span>
    <button mat-icon-button class="close-btn" (click)="snackBarRef.dismiss()">
        <mat-icon>close</mat-icon>
    </button>
</div>